// extracted by mini-css-extract-plugin
export default {"center":"Profile_center__RCp7P","Profile":"Profile_Profile__zqf9B"};